import {
  type CaseReducer,
  type PayloadAction,
  createSlice,
} from '@reduxjs/toolkit';

interface AnalyticsState {
  token: string;
}

const analyticsInitialState: AnalyticsState = {
  token: '',
};

export const analyticsSlice: ReturnType<
  typeof createSlice<
    AnalyticsState,
    {
      setAnalyticsToken: CaseReducer<
        AnalyticsState,
        PayloadAction<AnalyticsState['token']>
      >;
    },
    'analytics'
  >
> = createSlice({
  name: 'analytics',
  initialState: analyticsInitialState,
  reducers: {
    setAnalyticsToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const { setAnalyticsToken } = analyticsSlice.actions;
